import React from 'react';

const NotFound = () => {
  return (
    <>
      <div className="text-center p-5">
        <p className="display-1">404</p>
        <p className="display-4">Page Not Found</p>
      </div>
    </>
  );
};

export default NotFound;